import { createHash } from "node:crypto";
import type { AuthInfo } from "@modelcontextprotocol/sdk/server/auth/types.js";

export function getAuthenticatedRateLimitKey(
  authInfo: AuthInfo | undefined,
  fallbackIp: string | undefined,
): string {
  const extra = authInfo?.extra;
  if (isRecord(extra)) {
    if (extra.auth_type === "remote_api_key") {
      const clientId = getScalarValue(extra.client_id);
      if (clientId) {
        return `auth:api-client:${hashRateLimitValue(clientId)}:${getIpRateLimitKey(fallbackIp)}`;
      }
    }

    const teamId = getScalarValue(extra.team_id);
    const userId = getScalarValue(extra.user_id);

    if (teamId && userId) return `auth:team:${teamId}:user:${userId}`;
    if (userId) return `auth:user:${userId}`;
  }

  if (authInfo?.token)
    return `auth:token:${hashRateLimitValue(authInfo.token)}`;

  return getIpRateLimitKey(fallbackIp);
}

export function getTokenRouteRateLimitKey(
  token: string | undefined,
  fallbackIp: string | undefined,
): string {
  if (token) return `token:${hashRateLimitValue(token)}`;

  return getIpRateLimitKey(fallbackIp);
}

export function getIpRateLimitKey(ip: string | undefined): string {
  return `ip:${ip ?? "unknown"}`;
}

function hashRateLimitValue(value: string): string {
  return createHash("sha256").update(value).digest("hex");
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function getScalarValue(value: unknown): string | undefined {
  if (typeof value === "string" && value) return value;
  if (typeof value === "number" && Number.isFinite(value)) {
    return value.toString();
  }
  return undefined;
}
